/* TSM Prototypes – filtri catalogo, vista griglia/elenco, galleria prodotto, contatore carrello, link di accesso */
(function () {
  if (window.__tsmInit) return;
  window.__tsmInit = true;

  function initCatalog(root) {
    if (root.dataset.tsmReady) return;
    root.dataset.tsmReady = '1';
    var grid = root.querySelector('[data-tsm-products]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-tsm-card]'));
    var count = root.querySelector('[data-tsm-count]');
    var empty = grid.querySelector('[data-tsm-empty]');
    var selVehicle = root.querySelector('[data-tsm-filter="vehicle"]');
    var selType = root.querySelector('[data-tsm-filter="type"]');
    var selSort = root.querySelector('[data-tsm-sort]');

    function apply() {
      var v = selVehicle ? selVehicle.value : '';
      var t = selType ? selType.value : '';
      var n = 0;
      cards.forEach(function (c) {
        var ok = (!v || c.dataset.vehicle === v) && (!t || c.dataset.type === t);
        c.hidden = !ok;
        if (ok) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' prodotto' : ' prodotti');
      if (empty) empty.hidden = n !== 0;
      root.querySelectorAll('[data-tsm-vehicle-link]').forEach(function (a) {
        a.classList.toggle('is-active', !!v && a.dataset.tsmVehicleLink === v);
      });
    }

    function sort() {
      var mode = selSort ? selSort.value : '';
      var sorted = cards.slice().sort(function (a, b) {
        switch (mode) {
          case 'title-asc': return a.dataset.title.localeCompare(b.dataset.title);
          case 'title-desc': return b.dataset.title.localeCompare(a.dataset.title);
          case 'sku-asc': return a.dataset.sku.localeCompare(b.dataset.sku);
          case 'price-asc': return Number(a.dataset.price) - Number(b.dataset.price);
          case 'price-desc': return Number(b.dataset.price) - Number(a.dataset.price);
          default: return Number(a.dataset.index) - Number(b.dataset.index);
        }
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
      if (empty) grid.appendChild(empty);
    }

    if (selVehicle) selVehicle.addEventListener('change', apply);
    if (selType) selType.addEventListener('change', apply);
    if (selSort) selSort.addEventListener('change', sort);

    var viewBtns = root.querySelectorAll('[data-tsm-view]');
    function setView(view) {
      grid.classList.toggle('is-list', view === 'list');
      viewBtns.forEach(function (b) {
        var on = b.dataset.tsmView === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem('tsm-view', view); } catch (e) {}
    }
    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.tsmView); });
    });
    try { if (localStorage.getItem('tsm-view') === 'list') setView('list'); } catch (e) {}
  }

  function initGallery(root) {
    if (root.dataset.tsmReady) return;
    root.dataset.tsmReady = '1';
    var main = root.querySelector('.tsm-gallery__main img');
    if (!main) return;
    root.querySelectorAll('[data-tsm-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.src;
        main.srcset = '';
        main.alt = btn.dataset.alt || '';
        root.querySelectorAll('[data-tsm-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
  }

  /*
   * Link di accesso: dopo il login il cliente torna alla pagina indicata dal link
   * (return_url / return_to) oppure, se non indicata, alla pagina in cui si trovava,
   * invece di finire nell'area account di Shopify.
   */
  function initLoginLinks() {
    var here = window.location.pathname + window.location.search;
    document.querySelectorAll('.tsm a[href]').forEach(function (a) {
      if (a.dataset.tsmLogin) return;
      var href = a.getAttribute('href') || '';
      if (!/\/account\/login|\/customer_authentication\/(login|redirect)/.test(href)) return;
      var match = href.match(/[?&]return_(?:url|to)=([^&#]+)/);
      var target = here;
      if (match) {
        try { target = decodeURIComponent(match[1]); } catch (e) { target = here; }
      }
      if (target.charAt(0) !== '/' || target.charAt(1) === '/') target = here;
      a.setAttribute('href', '/customer_authentication/login?return_to=' + encodeURIComponent(target));
      a.dataset.tsmLogin = '1';
    });
  }

  function refreshCart() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-tsm-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('[data-tsm-cart-total]').forEach(function (el) {
          var fmt = el.dataset.format || '€ {{amount_with_comma_separator}}';
          var amount = (cart.total_price / 100).toFixed(2);
          var comma = amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          var dot = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          el.innerHTML = fmt
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
            .replace(/\{\{\s*amount\s*\}\}/, dot);
        });
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-tsm-catalog]').forEach(initCatalog);
    document.querySelectorAll('[data-tsm-gallery]').forEach(initGallery);
    initLoginLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:update', refreshCart);
})();
